/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthAdditionalFormType } from './PalReauthAdditionalFormType';
import {
    PalReauthAdditionalFormTypeFromJSON,
    PalReauthAdditionalFormTypeFromJSONTyped,
    PalReauthAdditionalFormTypeToJSON,
    PalReauthAdditionalFormTypeToJSONTyped,
} from './PalReauthAdditionalFormType';

/**
 * 
 * @export
 * @interface PalReauthSubmissionAdditionalForm
 */
export interface PalReauthSubmissionAdditionalForm {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    form_type: PalReauthAdditionalFormType;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    page_count?: number | null;
    /**
     * 
     */
    filesize_in_bytes?: number | null;
    /**
     * Signed URL, injected at read time and valid for one hour
     */
    access_url?: string | null;
}



/**
 * Check if a given object implements the PalReauthSubmissionAdditionalForm interface.
 */
export function instanceOfPalReauthSubmissionAdditionalForm(value: object): value is PalReauthSubmissionAdditionalForm {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('form_type' in value) || value['form_type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PalReauthSubmissionAdditionalFormFromJSON(json: any): PalReauthSubmissionAdditionalForm {
    return PalReauthSubmissionAdditionalFormFromJSONTyped(json, false);
}

export function PalReauthSubmissionAdditionalFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionAdditionalForm {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'form_type': PalReauthAdditionalFormTypeFromJSON(json['form_type']),
        'name': json['name'],
        'page_count': json['page_count'] === undefined ? undefined : json['page_count'] === null ? null : json['page_count'],
        'filesize_in_bytes': json['filesize_in_bytes'] === undefined ? undefined : json['filesize_in_bytes'] === null ? null : json['filesize_in_bytes'],
        'access_url': json['access_url'] === undefined ? undefined : json['access_url'] === null ? null : json['access_url'],
    };
}

export function PalReauthSubmissionAdditionalFormToJSON(json: any): PalReauthSubmissionAdditionalForm {
    return PalReauthSubmissionAdditionalFormToJSONTyped(json, false);
}

export function PalReauthSubmissionAdditionalFormToJSONTyped(value?: PalReauthSubmissionAdditionalForm | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'form_type': PalReauthAdditionalFormTypeToJSON(value['form_type']),
        'name': value['name'],
        'page_count': value['page_count'],
        'filesize_in_bytes': value['filesize_in_bytes'],
        'access_url': value['access_url'],
    };
}

